module.exports = __webpack_public_path__ + "img/ic_gg_rating.1bf8fb67.svg";